/**
 * Header Component - Application header with search
 */

import type { CompanyData } from '../../types'

interface HeaderProps {
  company: CompanyData | null
  searchValue: string
  onSearchChange: (value: string) => void
  onAnalyze: () => void
  isSearchFocused: boolean
  onSearchFocus: () => void
  onSearchBlur: () => void
}

export function Header({
  company,
  searchValue,
  onSearchChange,
  onAnalyze,
  isSearchFocused,
  onSearchFocus,
  onSearchBlur,
}: HeaderProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onAnalyze()
    }
  }

  return (
    <header className="border-b border-term-border bg-term-bg px-4 py-3">
      <div className="flex items-center justify-between gap-4">
        {/* Logo/Title */}
        <div className="flex items-center gap-3">
          <h1 className="text-lg font-semibold text-term-primary">
            PE Diligence
          </h1>
          {company && (
            <span className="text-term-textDim">
              │ <span className="text-term-text font-medium">{company.ticker}</span>{' '}
              <span className="text-term-textDim">{company.name}</span>
              {company.isPrivate && (
                <span className="ml-2 px-2 py-0.5 bg-term-info/30 text-term-info text-xs rounded font-bold">
                  PRIVATE
                </span>
              )}
            </span>
          )}
        </div>

        {/* Search */}
        <div className="flex items-center gap-2">
          <div className="relative">
            <input
              type="text"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyDown={handleKeyDown}
              onFocus={onSearchFocus}
              onBlur={onSearchBlur}
              placeholder="Company or ticker..."
              className={`term-input w-48 pl-8 ${isSearchFocused ? 'border-term-primary' : ''}`}
            />
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-term-textDim">
              /
            </span>
          </div>
          <button
            onClick={onAnalyze}
            className="term-button term-button-primary"
          >
            Analyze
          </button>
        </div>
      </div>
    </header>
  )
}
